import { render, staticRenderFns } from "./blocked_users.vue?vue&type=template&id=be5590d4&scoped=true&"
import script from "./blocked_users.vue?vue&type=script&lang=js&"
export * from "./blocked_users.vue?vue&type=script&lang=js&"
import style0 from "./blocked_users.vue?vue&type=style&index=0&id=be5590d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5590d4",
  null
  
)

export default component.exports